let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8zErG")).then(() => parcelRequire('e662T'));